import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { LoadingButton } from '@zillow/constellation';
import PropTypes from 'prop-types';
import { useFormState } from 'react-hook-form';

var _excluded = ["children"];
var ApexSubmit = function ApexSubmit(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  var formStateProxy = useFormState();
  var formState = {
    isSubmitting: formStateProxy.isSubmitting
  };
  return /*#__PURE__*/React.createElement(LoadingButton, _extends({
    type: "submit"
  }, rest, {
    disabled: formState.isSubmitting,
    loading: formState.isSubmitting
  }), children);
};
ApexSubmit.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node.isRequired
} : {};
ApexSubmit.defaultProps = {};
var ApexSubmit$1 = ApexSubmit;

export { ApexSubmit$1 as default };
